import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3z46kjdoak: FaireBrandEntity = {
  token: "b_3z46kjdoak",
  type: "brand",
  name: "Plant Therapy",
  avatarUrl:
    "https://cdn.faire.com/fastly/4fc25af783b7b5619f1ac5dd849afd3a72ea51b230c9e787f2f29a8a82d29b36.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6cb1fd2e93e1f167d6e63ac64b9260ce5321995d8c057df2e1560aaaaf05519e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4fc25af783b7b5619f1ac5dd849afd3a72ea51b230c9e787f2f29a8a82d29b36.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6cb1fd2e93e1f167d6e63ac64b9260ce5321995d8c057df2e1560aaaaf05519e.jpeg",
  location: "Twin Falls, ID, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 669,
  isTopShop: true,
  isInsider: true,
  description:
    "Founded in 2011 in Twin Falls, Idaho, Plant Therapy creates high-quality, accessibly priced wellness products designed to support real people in their everyday lives. What began as a small, family-run essential oil company has grown into a trusted natural wellness brand offering essential oils, body and hair care, home fragrances, and a growing line of supplements - all backed by rigorous testing and transparent standards.\n\nToday, our team of more than 85 employees is united by a clear purpose: to positively impact lives. That purpose guides every decision we make, from how we source and formulate our products to how we care for our customers.\n\nGiving back is also core to who we are. Through our Planting Kindness initiative and partnerships across southern Idaho, we’ve donated more than $6 million to charitable causes since 2011, supporting local families, education programs, and organizations addressing food insecurity and essential needs.\n\nAs we continue to evolve, our focus remains the same: creating safe, effective wellness solutions, staying grounded in our values, and making a meaningful difference in the communities we serve.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:19.976Z",
    importedBy: "entity-db-cli",
  },
};
